/**
 * validateStep7(acceptData)
 *
 * acceptData: { number: string, smallNumber: string }
 * Повертає об'єкт помилок { number?, smallNumber? }
 */
export function validateStep7(acceptData = {}) {
  const errors = {};

  const { number = '', smallNumber = '' } = acceptData;

  

  if (!smallNumber || !smallNumber.trim()) {
    errors.smallNumber = 'Табельний номер (скорочений) обов\'язковий';
  } else if (smallNumber.trim().length < 1) {
    errors.smallNumber = 'Табельний номер (скорочений) надто короткий';
  }

  return errors;
}